// Single source of truth for every favouritable / note-able algorithm.
//
// `slug` is the canonical identifier sent to the backend (favourites + notes).
// It MUST stay stable — changing a slug orphans existing favourites/notes.
// `route` matches the path registered in App.js so the dashboard can link back.
//
// Consumed by: MainSidebar (star toggles), MySpace dashboard (resolve a slug
// back to its label + route), and the notes "pick an algorithm" dropdown.

export const ALGORITHMS = [
  { slug: "sorting",             label: "Sorting Algorithms",   route: "/visualization/sorting",                 category: "Sorting" },
  { slug: "stack-queue",         label: "Stack & Queue",        route: "/visualization/stack-queue",             category: "Data Structures" },
  { slug: "linkedlist",          label: "Linked List",          route: "/visualization/linkedlist",              category: "Data Structures" },
  { slug: "travelling-salesman", label: "Travelling Salesman",  route: "/visualization/travelling-salesman",     category: "Optimization" },
  { slug: "lcs",                 label: "Longest Common Subsequence", route: "/visualization/lcs",               category: "Dynamic Programming" },
  { slug: "bfs",                 label: "Breadth First Search", route: "/visualization/shortest-path/bfs",       category: "Graph" },
  { slug: "dfs",                 label: "Depth First Search",   route: "/visualization/shortest-path/dfs",       category: "Graph" },
  { slug: "avl-trees",           label: "AVL Trees",            route: "/visualization/trees/avl-trees",         category: "Trees" },
  { slug: "tree-traversal",      label: "Tree Traversal",       route: "/visualization/trees/tree-traversal",    category: "Trees" },
  { slug: "red-black-tree",      label: "Red Black Tree",       route: "/visualization/trees/red-black-tree",    category: "Trees" },
  { slug: "naive-string",        label: "Naive String Matching", route: "/visualization/string/naive-string",    category: "String Matching" },
  { slug: "rabin-karp",          label: "Rabin Karp",           route: "/visualization/string/rabin-karp",       category: "String Matching" },
  { slug: "boyer-moore",         label: "Boyer Moore",          route: "/visualization/string/boyer-moore",      category: "String Matching" },
];

// Fast lookups by slug and by route.
export const ALGORITHM_BY_SLUG = ALGORITHMS.reduce((acc, a) => {
  acc[a.slug] = a;
  return acc;
}, {});

export const ALGORITHM_BY_ROUTE = ALGORITHMS.reduce((acc, a) => {
  acc[a.route] = a;
  return acc;
}, {});

// Resolve a route (sidebar link) to its slug, or null if it's not favouritable.
export const slugForRoute = (route) => ALGORITHM_BY_ROUTE[route]?.slug ?? null;
